const PUB = process.env.PUBLIC_URL || "";
const MARKS = [["visa", "Visa", "h-4"], ["mastercard", "Mastercard", "h-7"]];

// Visa / Mastercard acceptance marks (unaltered artwork from /brand/cards), each on a white tile for clear space.
export const CardMarks = ({ className = "", tone = "light", testid = "card-marks" }) => (
  <div className={`flex flex-wrap items-center gap-3 ${className}`} data-testid={testid}>
    <ul className="flex items-center gap-2" aria-label="Accepted cards">
      {MARKS.map(([k, label, h]) => (
        <li key={k} className="flex h-10 items-center rounded border border-slate-200 bg-white px-3">
          <img src={`${PUB}/brand/cards/${k}.svg`} alt={label} className={`${h} w-auto`} data-testid={`${testid}-${k}`} />
        </li>
      ))}
    </ul>
    <p className={`text-sm ${tone === "dark" ? "text-white/85" : "text-[#4A5568]"}`} data-testid={`${testid}-text`}>We accept Visa and Mastercard</p>
  </div>
);

export const BilledAs = ({ descriptor, className = "", testid = "billing-descriptor" }) => (descriptor ? (
  <p className={`text-sm text-[#4A5568] ${className}`} data-testid={testid}>
    Charges will appear on your card statement as <b className="font-mono text-navy">{descriptor}</b></p>
) : null);
